/**
 * withProductGroups
 * HOC for wrapping the provided component with ProductGroupsProvider
 */

import React from 'react'

import ProductGroupsProvider from './product-groups-provider'

export default function withProductGroups (WrappedComponent) {
  return function ProductGroupsProviderHOC(props) {
    return (
      <ProductGroupsProvider>
        <WrappedComponent {...props} />
      </ProductGroupsProvider>
    )
  }
}
